import { render, staticRenderFns } from "./CryptomatsAtms.vue?vue&type=template&id=a66f6a06&scoped=true&"
import script from "./CryptomatsAtms.vue?vue&type=script&lang=js&"
export * from "./CryptomatsAtms.vue?vue&type=script&lang=js&"
import style0 from "./CryptomatsAtms.vue?vue&type=style&index=0&id=a66f6a06&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a66f6a06",
  null
  
)

export default component.exports